import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import HeroSection from "../../../layout/HeroSection";
import Loader from "../../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import { fetchPartners } from "../../../redux/action/moreAction";
import PartnerList from "./PartnerList";

const Partners = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state?.homeReducer);

  useEffect(() => {
    dispatch(fetchPartners());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Header />
      <HeroSection
        label={<h1>{"Partners"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}/` },
          { name: "Partners" },
        ]}
      />
      <PartnerList/>

      {/* Start Testimonial Slider */}
      {/* <div
        class="testimonial-section untree_co-section "
        style={{backgroundColor: "#eee"}}
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-7 mx-auto text-center">
              <h2 class="section-title">
                <strong>Testimonials</strong>
              </h2>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-lg-12">
              <div class="testimonial-slider-wrap text-center">
                <div id="testimonial-nav">
                  <span class="prev" data-controls="prev">
                    <span class="fa fa-chevron-left"></span>
                  </span>
                  <span class="next" data-controls="next">
                    <span class="fa fa-chevron-right"></span>
                  </span>
                </div>

                <div class="testimonial-slider">
                  <div class="item">
                    <div class="row justify-content-center">
                      <div class="col-lg-8 mx-auto">
                        <div class="testimonial-block text-center">
                          <blockquote class="mb-5">
                            <p>
                              &ldquo;“We're a small and growing educational
                              services company, on the leading-edge of
                              educational technology. We look forward to
                              building your next project, or training your
                              staff. Let's create something amazing, together!​"
                              &rdquo;
                            </p>
                          </blockquote>

                          <div class="author-info">
                            <div class="author-pic">
                              <img
                                src="images/person-1.png"
                                alt="Maria Jones"
                                class="img-fluid"
                              />
                            </div>
                            <h3 class="font-weight-bold">Christopher Miko</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                 
                  <div class="item">
                    <div class="row justify-content-center">
                      <div class="col-lg-8 mx-auto">
                        <div class="testimonial-block text-center">
                          <blockquote class="mb-5">
                            <p>
                              &ldquo;“We're a small and growing educational
                              services company, on the leading-edge of
                              educational technology. We look forward to
                              building your next project, or training your
                              staff. Let's create something amazing, together!​"
                              &rdquo;
                            </p>
                          </blockquote>

                          <div class="author-info">
                            <div class="author-pic">
                              <img
                                src="images/person-1.png"
                                alt="Maria Jones"
                                class="img-fluid"
                              />
                            </div>
                            <h3 class="font-weight-bold">Christopher Miko</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <Footer />
    </div>
  );
};

export default Partners;
